function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}
module.exports = _complement;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_complement.js
// module id = 313
// module chunks = 0